import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ApiServiceProject } from '../../../apis/ApiServiceProject';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { ListAssigned, ProjectDetailsDto, ListWeek, ListProgress, ListStages, ListRisksMatrix, ListMilestones, ViewRisk, ListDependence } from '../../../interfaces/project/list/projectDetailsDto';
import { stageProject } from 'src/app/web/interfaces/project/stages/stageProject';
import { DataTableDirective } from 'angular-datatables';
import { Subject, Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { TableOneSearch } from 'src/app/web/util/formatDataTable';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

export class listPay {

  id: number;
  date_pay: string;
  description: string;
  listProjectPlayIntoInfo: any
  
}

export class listPaylist {

    hes: string;
    facture: string;
    facture_date: string;
  
  
}

export class infolistPay {

  id: number;
  title: string;
  scheduled_date: string;
  rescheduled_date: string;
  real_date: string;
  status: string;
  anexo: string;
  name: string;
  pay_amount: string;
  amount_percent: string;


}

@Component({
  selector: 'app-pay-into-project',
  templateUrl: './pay-into-project.component.html',
  styleUrls: ['./pay-into-project.component.scss']
})
export class PayIntoProjectComponent implements OnInit {


  title = "Datos"
  idProject: number;
  id: number;
  nameProject: string;
  paymentsform: FormGroup;
  projectStages: stageProject[] = [];
  developersTeam: ListAssigned[] = [];
  createPay: listPay;
  createPaylist: listPaylist;
  listAnexo: any[] = [];
  datos: infolistPay;
  listMoney: any[] = [];
  private apiService: ApiServiceProject;
  createPayForm: FormGroup;
  infoPayForm: FormGroup;
  idSubscription: Subscription;
  items!: FormArray;


  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private fb: FormBuilder,
    private errorService:ErrorService

  ) {

    this.route.params.subscribe((params) => {
      this.id = params['idPay'];
      this.idProject = params['idProject'];
      this.title = params['name']
    });
  }

  ngOnInit(): void {

    this.paymentsform = this.fb.group({
      items: new FormArray([])
    });

    this.items = this.paymentsform.get("items") as FormArray

    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

    this.createPayForm = this.fb.group({
      id: [0],
      date_pay: [''],
      description: [''],
    });

    this.infoPayForm = this.fb.group({
      id: [0],
      date_reschedule: [''],
      description: [''],
    });

    this.apiService = new ApiServiceProject(this.http);

    let rs = JSON.parse(localStorage.getItem("info-mtn"));

    rs.listProjectPlay.map((dato) => {
      if (dato.id == this.id) {
        this.datos = dato;

      }
    })



  }
  nuevoCampo() {
    this.items = this.paymentsform.get("items") as FormArray
    let info = this.fb.group({
      hes: "",
      facture: "",
      facture_date: ""
    });

    this.items.push(info)

  }

  eliminarCampo(index) {
  this.items.removeAt(index)
  }


  transformName(name: string): string {
    let names = name.split('.');
    let nameString = "";
    for (let name of names) {
      nameString += name.charAt(0).toUpperCase() + name.slice(1) + " ";
    }
    return nameString;
  }



  formSubmit(): void {
    this.spinner.show();

    if (this.createPayForm.value.date_pay === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe seleccionar una fecha' ,text: '',icon: 'error',heightAuto: false});
      return;
    }

    if (this.createPayForm.value.description === '') {
      this.spinner.hide();
      Swal.fire({title:'Debe rellenar una descripción' ,text: '',icon: 'error',heightAuto: false});
      return;
    }
   
    this.createPay = new listPay();
    this.createPay.id = Number(this.id);
    this.createPay.date_pay =  moment(this.createPayForm.value.date_pay).format("DD-MM-YYYY");
    this.createPay.description = this.createPayForm.value.description;

   
    this.createPay.listProjectPlayIntoInfo = []

  for(let info of this.items.value){

    let payInfo = {
      hes: info['hes'],
      facture:info['facture'],
      facture_date: moment(info['facture_date']).format("DD-MM-YYYY")
    }

    this.createPay.listProjectPlayIntoInfo.push(payInfo)
  }

   
  this.apiService.postService('project-play-into', this.createPay)
      .subscribe({
        next: (data: any) => {
          this.spinner.hide();
          Swal.fire({title:'Exito!',text:data.message,icon: 'success',heightAuto: false})
            .then(() => [
            ]);
           this.router.navigate(['/pdg/project/pay/list', this.idProject, this.title]);
        },
        error: (error) => {
          this.errorService.error(error);
        }
      });
  }

  valideNegative(monto){
    if(monto.toString().includes("-")){
      return true
    }
    return false
  }
}